import React from 'react';
import { Box } from '@material-ui/core';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import { useTranslate } from 'react-admin';
import ShowNoteSignsItem from './ShowNoteSignsItem';
import NoteItemCollapse from './NoteItemCollapse';

interface SignItem {
    id: string;
    customFields?: {
        imageDataBase64?: string;
        name?: string;
        [key: string]: any;
    };
    [key: string]: any;
}

interface Props {
    signs: SignItem[];
}

// Enhanced ShowNoteSigns aligned with platform-v2, adapted to Material-UI v4
const ShowNoteSigns: React.FC<Props> = ({ signs }) => {
    const t = useTranslate();
    if (!signs || signs.length === 0) return null;

    return (
        <NoteItemCollapse title={t('app.signs') || 'Firmas'} icon={<BorderColorIcon />}>
            <Box
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 8,
                    justifyContent: 'center',
                    padding: 8,
                }}
            >
                {signs.map((s: SignItem, idx: number) => (
                    <ShowNoteSignsItem
                        key={s.id || idx}
                        imageDataBase64={s?.customFields?.imageDataBase64 || ''}
                        name={s?.customFields?.name || ''}
                    />
                ))}
            </Box>
        </NoteItemCollapse>
    );
};

export default ShowNoteSigns;
